<template>
  <div id="registrationPage" :class="{ 'top-space': formShow }">
    <template v-if="formShow">
      <!-- 1st card -->
      <div class="select-screen">
        <div class="card">
          <h1 class="hat">Facilitator Information</h1>
          <div class="header">
            <div class="title">Tell Us About Yourself...</div>
            <div class="required-notification">All fields are required</div>
          </div>
          <div class="content">
            <div class="group">
              <FormInput
                type="text"
                label="First Name"
                name="firstName"
                v-model.trim="v$.form1.firstName.$model"
                :valid="!v$.form1.firstName.$error"
              />
              <FormInput
                type="text"
                label="Last Name"
                name="lastName"
                v-model.trim="v$.form1.lastName.$model"
                :valid="!v$.form1.lastName.$error"
              />
            </div>

            <FormInput
              class="field"
              type="phone"
              label="Work Phone Number"
              name="phone"
              v-model.trim="v$.form1.phoneNumber.$model"
              :valid="!v$.form1.phoneNumber.$error"
            />

            <div class="field">
              <FormInput
                type="email"
                label="Email (Account ID)"
                name="email"
                v-model.trim="v$.form1.email.$model"
                :valid="!v$.form1.email.$error"
              />
              <p class="email-message">
                {{ v$.form1.email.$model }} --- This email will be used as your account login ID
              </p>
              <transition name="expand">
                <p
                  class="email-message error"
                  v-if="!v$.form1.email.required.$invalid && !v$.form1.email.email.$invalid && v$.form1.email.$error"
                >
                  Sorry, this email has already been used to register an account
                </p>
              </transition>
            </div>

            <div class="field">
              <FormInput
                type="text"
                label="Create your Account Password"
                name="password"
                v-model.trim="v$.form1.password.$model"
                :valid="!v$.form1.password.$error"
              />
              <div id="pw-msg">At least eight characters with a lower case letter, Upper case letter, and a number</div>
            </div>
          </div>
        </div>
      </div>
      <!-- end 1st card -->

      <!-- 2nd card -->
      <div class="select-screen">
        <div class="card">
          <h1 class="hat">Agency Information</h1>
          <div class="header">
            <div class="title">Lastly, Tell Us About Your Agency…</div>
            <div class="required-notification">All fields are required</div>
          </div>

          <div class="content">
            <div class="field">
              <FormSearchSelector
                label="Agency Name"
                gradual
                name="agency"
                v-model="v$.form1.agencyId.$model"
                :valid="!v$.form1.agencyId.$error"
                :dataList="agencyList"
              />
              <transition name="expand">
                <FormInput
                  v-if="this.form1.agencyId === -1"
                  type="text"
                  label="Type in your agency here"
                  name="newAgency"
                  v-model.trim="v$.form1.newAgencyName.$model"
                  :valid="!v$.form1.newAgencyName.$error"
                />
              </transition>
            </div>

            <FormSearchSelector
              class="field"
              gradual
              label="Province"
              name="province"
              v-model="v$.form1.provinceId.$model"
              :valid="!v$.form1.provinceId.$error"
              :dataList="provinceList"
            />

            <FormInput
              class="field"
              type="text"
              label="Business Address | # Street Name, Suite/Unit #"
              name="address"
              v-model.trim="v$.form1.address.$model"
              :valid="!v$.form1.address.$error"
            />

            <div class="group">
              <FormSearchSelector
                class="field"
                gradual
                label="City"
                name="city"
                v-model="v$.form1.cityId.$model"
                :valid="!v$.form1.cityId.$error"
                :dataList="availableCities"
              />

              <FormInput
                class="field"
                label="Postal Code"
                name="postcode"
                v-model.trim="v$.form1.postcode.$model"
                :valid="!v$.form1.postcode.$error"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- end 2nd card -->

      <div class="next-btn-container">
        <button type="submit" class="next" @click="completeForm">Next</button>
      </div>

      <ScrollCardFade id="nav-box" screen-group-selector=".select-screen" />

      <!-- MUST REMOVE THIS BUTTON FOR PRODUCTION -->
      <!-- <button
        type="button"
        :style="{
          display: 'none1',
          position: 'absolute',
          right: '1em',
          top: '1em',
          border: '0 none',
          borderRadius: '0.5em',
          boxShadow: '1px 1px 4px 0 #000',
          padding: '0.6em 1.2em',
          background: 'yellowgreen',
          color: '#FFF',
          fontSize: '1.2em',
          cursor: 'pointer',
        }"
        v-on:click="setDebugForm"
      >
        Dev button - fill form
      </button> -->
    </template>

    <transition-group name="quick-fade">
      <div class="tos-box" v-if="TOSShow">
        <TOSform :clientData="form1" @onSubmitted="completeRegistration" />
      </div>

      <SignUpThankYou v-if="showThankYou" :data="{ firstName: form1.firstName, email: form1.email }" />
    </transition-group>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, alphaNum, minLength, maxLength, email, helpers } from '@vuelidate/validators';
import { mapState } from 'vuex';

// New versions

import ScrollCardFade from '@/components/common/ScrollCardFade.vue';
import FormInput from '@/components/form/FormInput.vue';
import FormSearchSelector from '@/components/form/FormSearchSelector.vue';
import isPostalCodeValid from '@/components/form/formValidators/isPostalCodeValid';
import SignUpThankYou from '@/components/registration/SignUpThankYou.vue';
import TOSform from '@/components/registration/TOS.vue';
import API from '@/service/hub-api';

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      // Form Data
      form1: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        password: '',

        agencyId: null,
        newAgencyName: '',
        provinceId: null,
        address: '',
        cityId: null,
        postcode: '',
      },

      formShow: true, // true
      TOSShow: false, // false
      showThankYou: false, // false
    };
  },

  validations: {
    form1: {
      firstName: {
        required,
        alphaNum,
        minLength: minLength(3),
        maxLength: maxLength(16),
      },
      lastName: {
        required,
        alphaNum,
        minLength: minLength(3),
        maxLength: maxLength(16),
      },
      phoneNumber: {
        required,
        isPhoneValid(value) {
          return /^\([0-9]{3}\) [0-9]{3} - [0-9]{4}$/.test(value);
        },
      },
      email: {
        $lazy: true,
        required,
        email,
        isUnique: helpers.withAsync((value) => {
          if (!value || !email.$validator(value)) {
            return true;
          }

          return new Promise((resolve) => {
            API.get(`/facilitator/email/${value}`)
              .then((response) => {
                resolve(response.success);
              })
              .catch(() => resolve(false));
          });
        }),
      },
      password: {
        required,
        isPasswordValid(value) {
          const passRegex = /^(?=.*[0-9])(?=.*[A-z])(?=.*[!@#$%^&*()[\]\\/'":;,.?-_=?]).{8,}$/;
          return passRegex.test(value);
        },
      },

      //
      agencyId: {
        required,
        isAgencyValid(value) {
          return this.agencyList.map((item) => item.id).includes(value);
        },
      },
      newAgencyName: {
        requiredIfOther(value) {
          if (this.form1.agencyId > 0) return true;
          return value.length;
        },
      },
      provinceId: {
        required,
        isProvinceValid(value) {
          return this.provinceList.map((item) => item.id).includes(value);
        },
      },
      address: {
        required,
      },
      cityId: {
        required,
        isCityValid(value) {
          return this.availableCities.map((item) => item.id).includes(value);
        },
      },
      postcode: {
        required,
        isPostalCodeValid,
      },
    },
  },

  methods: {
    completeForm() {
      // actons on 'next' button press
      this.v$.$touch();

      if (this.v$.$invalid) {
        // console.log('###INVALID');
      } else {
        // console.log('###VALID');
        this.formShow = false;
        this.TOSShow = true;
      }
    },

    completeRegistration() {
      this.TOSShow = false;
      this.showThankYou = true;
      this.$emit('onSuccess');
    },

    capitalizeString(string) {
      return string
        .toLowerCase()
        .split(' ')
        .map((word) => [word.substr(0, 1).toUpperCase(), word.substr(1)].join(''))
        .join(' ');
    },

    setDebugForm() {
      // for development purpose ONLY. MUST REMOVE THIS FUNCTION AND BUTTON FOR PRODUCTION
      // console.log('using dev values');
      this.v$.form1.firstName.$model = 'sampleName';
      this.v$.form1.lastName.$model = 'sampleLastName';
      this.v$.form1.phoneNumber.$model = '(213) 412 - 3123';
      this.v$.form1.email.$model = 'sampleEmail@sample.ca';
      this.v$.form1.password.$model = 'aA1!5678';
      this.v$.form1.agencyId.$model = 36;
      this.v$.form1.newAgencyName.$model = 'Operation Springboard';
      this.v$.form1.provinceId.$model = 7;
      this.v$.form1.address.$model = 'aA1!5678';
      this.v$.form1.postcode.$model = 'L4C 5T9';

      this.$nextTick(() => {
        this.v$.form1.cityId.$model = 34;
      });
    },
  },

  computed: {
    ...mapState({
      agencyList: (state) => state.meta.agencyList.concat({ id: -1, name: 'Other...' }),
      provinceList(state) {
        return state.meta.provinceList.map((province) => ({
          id: province.id,
          name: this.capitalizeString(province.name),
        }));
      },
      cityList(state) {
        return state.meta.cityList.map((city) => ({
          id: city.id,
          name: this.capitalizeString(city.name),
          province_id: city.province_id,
        }));
      },
    }),
    availableCities() {
      return this.cityList.filter((city) => city.province_id === this.form1.provinceId);
    },
  },

  components: {
    // new versions
    FormInput,
    FormSearchSelector,
    //
    ScrollCardFade,
    //
    TOSform,
    SignUpThankYou,
  },
};
</script>

<style scoped>
#registrationPage {
  width: 100%;
  height: 100%;
}
#registrationPage.top-space {
  padding-top: 10em;
}

.select-screen {
  box-sizing: border-box;
  padding: 8em 1em 0;
}

/** Card contents */
.card {
  position: relative;
  box-sizing: border-box;
  border-radius: 1em;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.5);
  padding: 3em 2em;
  background: #fff;
  color: rgb(99, 99, 99);
  font-size: 1.1em;
}
.card .hat {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -180%);
  color: #fff;
  font-size: 1.6em;
  white-space: nowrap;
}
.card .header {
  display: grid;
  grid-template-columns: repeat(auto-fit, 100%);
  row-gap: 0.5em;
}
.card .title {
  color: rgb(130, 130, 130);
  font-size: 1.2em;
  font-weight: bold;
}

.card .required-notification {
  color: #df195f;
}

.card .content {
  margin-top: 1em;
}

.card .field {
  position: relative;
  width: 100%;
}

/** Field rules */
.card #pw-msg,
.card .email-message {
  margin: 0;
  padding: 0;
  color: rgb(130, 130, 130);
  font-style: italic;
  font-size: 0.9em;
}
.card .email-message.error {
  margin-top: 0.5em;
  color: #df195f;
}

/** Next button */
.next-btn-container {
  padding: 3em 0;
  text-align: center;
}
.next-btn-container > button {
  border: 0 none;
  border-radius: 0.5em;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.5);
  padding: 0.8em 6em;
  background: #fff;
  color: rgb(99, 99, 99);
  font-size: 1.2em;
  cursor: pointer;
}

/** TOS Box */
.tos-box {
  width: 100%;
  height: 100%;
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  #registrationPage {
    width: 85%;
  }
  #registrationPage.top-space {
    padding-top: 8em;
  }

  .select-screen {
    padding: 8em 0 0;
  }

  .card .hat {
    left: 0;
    top: 0;
    transform: translate(0.5em, -180%);
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  #registrationPage {
    max-width: 60em;
    width: 85%;
  }

  .select-screen {
    padding: 8em 0 0;
  }

  .card {
    padding: 4em 3em;
  }

  .card .hat {
    left: 0;
    top: 0;
    transform: translate(0.5em, -180%);
  }

  .card .content .group {
    display: grid;
    grid-template-columns: repeat(2, 45%);
    justify-content: space-between;
  }
}

/**
 * TRANSITIONS
 */

/** Expand transition */
.expand-enter-active,
.expand-leave-active {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s linear;
}
.expand-enter-from,
.expand-leave-to {
  max-height: 0;
}
.expand-enter-to,
.expand-leave-from {
  max-height: 10em;
}

/** Form fade transition */
.quick-fade-enter-active,
.quick-fade-leave-active {
  transition: opacity 2s;
}
.quick-fade-enter,
.quick-fade-leave-to {
  opacity: 0;
}
</style>
